import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import TripAdvisorRatingImage from "app/pages/FicheProduit/components/TripAdvisor/TripAdvisorRatingImage/TripAdvisorRatingImage";
import "./TripAdvisorRating.scss";

const TripAdvisorRating = ({ rating = 0, ranking_string, reviewsCount, showRanking = false }) => {
	const ratingValueString =
		rating.toString().indexOf(".") === -1 ? rating + ".0" : rating.toString();

	const tripadvisorRating =
		Math.round(rating) > 5 || Math.round(rating) < 0 ? 0 : Math.round(rating);

	return (
		<div className="tripadvisor-rating" data-testid="tripadvisor-note">
			<div className="tripadvisor-rating__infos">
				<div className="tripadvisor-rating__note">
					{rating >= 0 && rating <= 5 ? ratingValueString : "0.0"}
				</div>
				<div className="tripadvisor-rating__status">
					<FormattedMessage id={`tripadvisor.status.${tripadvisorRating}`} />
				</div>
				<TripAdvisorRatingImage rating={rating} reviewsCount={reviewsCount} />
			</div>
			{showRanking && <p className="tripadvisor-rating__ranking">{ranking_string}</p>}
		</div>
	);
};

TripAdvisorRating.propTypes = {
	rating: PropTypes.number,
	ranking_string: PropTypes.string,
	reviewsCount: PropTypes.number,
	showRanking: PropTypes.bool,
};

export default memo(TripAdvisorRating);
